export const GET_ALL_LEAGUES = "GET_ALL_LEAGUES";
export const ADD_LEAGUE = "ADD_LEAGUE";
export const GET_ALL_AVAILABLE_LEAGUES = "GET_ALL_AVAILABLE_LEAGUES";
export const EDIT_LEAGUE = "EDIT_LEAGUE";
export const CLEAR_ALL_LEAGUES = "CLEAR_ALL_LEAGUES";